import { InjectionToken } from '@angular/core';

import { IThingDirectoryFilter } from '../services/thing-directory/thing-directory-interface';

/*
  A token to modify the current thing directory as for example appending an instance id search param
*/
export const THING_DIRECTORY_FILTER = new InjectionToken<IThingDirectoryFilter>('ThingDirectoryFilter');
